import _default from './Embed';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/modules/Embed/index.js
// module id = 981
// module chunks = 0